export default __webpack_public_path__ + "static/media/vortex.d64c6321.png";